import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { trans } from '../../../localization/language';
import { ACCOUNT_TYPE, ACCOUNT_TYPE_TEMPLATE, VERIFICATION_TOOL } from '../../../constants';
import * as verificationActions from '../../../actions/verification';
import { getSendOTPErrorMessage, getVerifyOTPErrorMessage } from '../../../utils.js'
import MobileOtpInputField from './MobileOtpInputField';

class OtpVerification extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			code: '',
			gatewayBefore: undefined,
			ac_type: props.ac_type
		}
	}

	handleSubmit(event) {
		event.preventDefault();
		this.props.submitCode(this.state.code, this.state.ac_type, VERIFICATION_TOOL.MOBILE);
	}

	handleChangeCode(event) {
		this.setState({code: event.target.value});
	}

	checkError() {
		var errMsg = null;
		if (this.props.verification.get_status) {
			errMsg = getSendOTPErrorMessage(this.props.verification.get_status);
		} else if (this.props.verification.verify_status) {
			errMsg = getVerifyOTPErrorMessage(this.props.verification.verify_status);
		}
		if (errMsg) {
			return (
				<div className="content__form-errmsg-item content__form-errmsg-item--visible">
					{errMsg}
				</div>
			);
		}
	}
	
	render() {
		const template = ACCOUNT_TYPE_TEMPLATE[this.props.ac_type];
		const gatewayBefore = trans(this.state.gatewayBefore || 'sms_gateway');
		const gatewayAfter = trans(this.props.verification.gateway || 'sms_gateway');

		return (
			<div className="content-item__main">
				<div className="content-item--ipage__main">
					<div className="content__sendinfo" id="J-sendinfo">
						{this.props.ac_type == ACCOUNT_TYPE.OTPTOKEN && <div className="content__sendinfo-before">
							{trans('revoke_token_hint')}
						</div>}
						<div className="content__sendinfo-before">{trans('get_otp_hint', { gateway: gatewayBefore })}</div>
						<div className="content__sendinfo-after">
							{trans('sent_opt_info', { gateway: gatewayAfter })}
						</div>
					</div>
					<div className="content__form">
						<form method="post" action="" id="J-validated-form" onSubmit={this.handleSubmit.bind(this)}>
							<div className="content__phone">
								<div className="content__phone-icon"></div>
								<div className="content__phone-num">{this.props.mobile_no}</div>
							</div>
							{!!this.props.userInfo.country_code && (
								<MobileOtpInputField
									template_id={template.template_id}
									template_params={template.template_params}
									value={this.state.code}
									onChange={this.handleChangeCode.bind(this)}
									onChangeGateway={(gatewayBefore) => this.setState({ gatewayBefore })}
								/>
							)}	
							<div className="content__form-errmsg" id="J-errdisplay-otp">
								{this.checkError()}
							</div>
							<div className="content__submit-wrap">
								<input type="submit" className="content__submit" value={trans('verify_btn')}></input>
							</div>
						</form>
					</div>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		userInfo: state.data.userInfo,
		verification: state.verification
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(Object.assign({}, verificationActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(OtpVerification);


// WEBPACK FOOTER //
// ./app/components/security/verification/OtpVerification.js